import axios from "axios";
const token = localStorage.getItem("accessToken");

const config = {
  headers: { Authorization: `Bearer ${token}` },
};

export const baseService = {
  get: async function (url, onSuccess, onError) {
    return await axios
      .get(url, config)
      .then(function (response) {
        onSuccess(response);
      })
      .catch(function (error) {
        console.log(error);
        onError(error.response);
      });
  },
  post: async function (url, payload, onSuccess, onError) {
    return await axios
      .post(url, payload, config)
      .then(function (response) {
        onSuccess(response);
      })
      .catch(function (error) {
        console.log(error);
        onError(error.response);
      });
  },
  patch: async function (url, payload, onSuccess, onError) {
    return await axios
      .patch(url, payload, config)
      .then(function (response) {
        onSuccess(response);
      })
      .catch(function (error) {
        console.log(error);
        onError(error.response);
      });
  },
  put: async function (url, payload, onSuccess, onError) {
    return await axios
      .put(url, payload, config)
      .then(function (response) {
        onSuccess(response);
      })
      .catch(function (error) {
        console.log(error);
        onError(error.response);
      });
  },
  delete: async function (url, onSuccess, onError) {
    return await axios
      .delete(url, config)
      .then(function (response) {
        onSuccess(response);
      })
      .catch(function (error) {
        console.log(error);
        onError(error.response);
      });
  },
};
